<template>
  <div class="home">
    <app-swiper1></app-swiper1>
    <app-break1></app-break1>
    <app-swiper5></app-swiper5>
    <app-break1></app-break1>
    <app-swiper6></app-swiper6>
    <div
      class="swiper_normal"
      :key="(item, index)"
      v-for="(item, index) in data_s"
    >
      <div class="swiper_normal__container">
        <div class="titr__normal">
          <router-link
            style="text-decoration: none"
            :to="{
              name: 'list',
              params: { id: item.cat.slug },
            }"
            class="titr__normal--p"
          >
            {{ item.cat.name }}
          </router-link>
        </div>

        <swiper class="swiper" ref="swiper" :options="swiperOption">
          <swiper-slide
            class="swiper-item"
            :key="(item, index)"
            v-for="(item, index) in item.products"
          >
            <router-link
              :to="{
                name: 'detail',
                params: { id: item.slug },
              }"
              class="swiper-item__link"
            >
              <p class="offer" v-if="item.special_offer == true">فروش ویژه</p>
              <p class="offer" v-else>پیشنهاد ویژه</p>
              <img :src="item.image" alt="" class="swiper-item__link_img" />
              <p class="swiper-item__link_name">
                {{ item.name.toLocaleString("fa").toPersianDigits() }}
              </p>
              <div class="dec_pri">
                <p class="swiper-item__link_prise" v-if="item.discount != 0">
                  {{ item.price.toLocaleString("fa").toPersianDigits() }} تومان
                </p>
                <p class="swiper-item__link_dec" v-if="item.discount != 0">
                  {{ item.discount.toLocaleString("fa").toPersianDigits() }}٪
                </p>
              </div>
              <p v-if="item.discount != 0" class="swiper-item__link_prise_dec">
                {{ item.dis_price.toLocaleString("fa").toPersianDigits() }}
                تومان
              </p>
              <p v-if="item.discount == 0" class="swiper-item__link_prise_dec">
                {{ item.price.toLocaleString("fa").toPersianDigits() }}
                تومان
              </p>
            </router-link>
          </swiper-slide>

          <!-- <div
            class="swiper-button-prev"
            slot="button-prev"
            @click="prev()"
          ></div>
          <div
            class="swiper-button-next"
            slot="button-next"
            @click="next()"
          ></div> -->
        </swiper>
        <hr />
      </div>
    </div>
    <!-- <app-swiper3></app-swiper3> -->
    <app-break1></app-break1>
  </div>
</template>
<script>
import swiper1 from "./components/swiper1.vue";
import swiper5 from "./components/swiper5.vue";
import swiper6 from "./components/swiper6.vue";
import swiper2 from "./components/swiper2.vue";
import swiper3 from "./components/swiper3.vue";
import break1 from "./components/break1.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  components: {
    appSwiper1: swiper1,
    appSwiper2: swiper2,
    appSwiper3: swiper3,
    appSwiper5: swiper5,
    appSwiper6: swiper6,
    appBreak1: break1,
    Swiper,
    SwiperSlide,
  },
  methods: {
    prev() {
      // console.log(this.$refs);
      // this.$refs.swiper.$swiper.slidePrev();
    },
    next() {
      // this.$refs.swiper.$swiper.slideNext();
    },
  },
  data() {
    return {
      data_s: [],
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 2,
        slidesPerGroup: 1,
        breakpoints: {
          1024: {
            slidesPerView: 5,
            spaceBetween: 40,
          },
          700: {
            slidesPerView: 3,
            spaceBetween: 5,
          },
          500: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 200,
          },
        },
        // loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      userData: {
        name: this.$route.params.id,
        descript: `در این صفحه جزييات محصول ${name} همراه با رنگ ها و قیمت ${name} قرار گرفته شده است`,
      },
    };
  },
  // name: "sunCandle",
  metaInfo() {
    return {
      title: `فروشگاه شمع خورشید`,
      meta: [
        {
          name: "description",
          content: `کارگاه شمع خورشید ارایه کننده کلیه وسایل شمع سازی و ملزومات کارگاه های تولید شمع و آموزش شمع سازی و انواع دستگاه شمع سازی و قالب های شمع`,
        },
        {
          property: "og:title",
          content: "فروشگاه شمع خورشید",
        },

        { property: "og:site_name", content: "فروشگاه شمع خورشید" },
        { property: "og:type", content: "home" },
      ],
    };
  },
  created() {
    String.prototype.toPersianDigits = function () {
      var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return this.replace(/[0-9]/g, function (w) {
        return id[+w];
      });
    };
    var that = this;
    this.$store.state.load = true;

    var that = this;
    // console.log(this.$store.state.ban, "fffffffffffffffff");

    if (localStorage.getItem("profile") == null) {
      $.ajax({
        url: that.$store.state.url + "api/v1/pages/index/",
        crossDomain: true,
        xhrFields: {
          withCredentials: true,
        },
        type: "GET",
        success: function (data, textStatus, request) {
          console.log(data);
          that.data_s = data.base_cats;
          that.$store.state.load = false;
          that.$store.state.index = data;
        },
        error: function (request, textStatus, errorThrown) {
          if (request.state == 500) {
            that.$toastr.e("خطایی در سرور به وجود امده");
            that.$store.state.e500 = true;
          } else {
            that.$store.state.e404 = true;
            that.$toastr.e("خطا در برقراری ارتباط");
          }
        },
        complete: function () {},
      });
    } else {
      $.ajax({
        url: that.$store.state.url + "api/v1/pages/index/",
        crossDomain: true,
        xhrFields: {
          withCredentials: true,
        },
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("profile"),
        },
        type: "GET",
        success: function (data, textStatus, request) {
          // console.log(data);
          that.$store.state.index = data;
          that.data_s = data.base_cats;
          that.$store.state.load = false;
          // console.log("ayval");
        },
        error: function (request, textStatus, errorThrown) {
          if (request.state == 500) {
            that.$toastr.e("خطایی در سرور به وجود امده");
            that.$store.state.e500 = true;
          } else {
            that.$store.state.e404 = true;
            that.$toastr.e("خطا در برقراری ارتباط");
          }
        },
        complete: function () {},
      });
    }
  },
};
</script>
<style lang="scss">
.home {
}

// @import "./base.scss";
.offer {
  color: var(--shrink);
  width: 90%;
  font-size: 0.9em;
  padding-bottom: 0.5em;
  text-align: center;
  border-bottom: 1px solid var(--shrink);
  @media screen and (max-width: 500px) {
    width: 100%;
  }
}
.last {
  // background: brown;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  a {
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column-reverse;
  }
  &__sign {
    border: 1px solid orange;
    font-size: 2em;
    padding: 0.5em;
    height: 60px;
    width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    padding-top: 0.5em;
    color: orange;
    margin-bottom: 1em;
  }
  &__text {
    color: var(--font-color);
  }
}
.titr__normal {
  position: absolute;
  flex-direction: column;
  width: 20%;
  height: auto;
  margin-left: 0;
  //   background: red;
  display: flex;
  justify-content: center;
  align-items: center;
  top: -30px;
  right: 12px;
  z-index: 9;
  background: var(--main-color);
  border-radius: 10px;
  box-shadow: 0 -3px 2px rgba(0, 0, 0, 0.212);
  @media screen and (max-width: 657px) {
    top: -15px;
    border-radius: 5px;
    width: 30%;
  }
  @media screen and (max-width: 500px) {
    top: -15px;
    border-radius: 5px;
    width: 30%;
  }
  &--p {
    font-family: "lalezar";
    color: var(--sub-color);
    font-size: 1.5em;
    text-align: center;
    @media screen and (max-width: 657px) {
      font-size: 1em;
    }
    @media screen and (max-width: 500px) {
      font-size: 1em;
    }
  }
}
.swiper {
  width: 98%;
  height: 90%;
  // background: blue;
  margin-left: 1.2em;
  padding-left: 0.8em;
  padding-right: 0.5em;
  // background: blueviolet;
}
.swiper_normal {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  width: 98%;
  // background: red;
  height: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
  direction: rtl;
  // // position: absolute;
  // // top: 150px;
  margin-top: 3em;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.212);
  border-radius: 10px;
  // // width: 100%;
  // // height: 100vh;
  // // padding-right: 20em;
  // // background: var(--sub-color);
  //   box-shadow: 0 0 5px black;
  @media screen and (max-width: 900px) {
    // border-radius: 8px;
    width: 98%;
    // width: 100%;
    height: 450px;
  }
  @media screen and (max-width: 800px) {
    // border-radius: 8px;
    width: 98%;
    // width: 100%;
    height: 450px;
  }
  @media screen and (max-width: 500px) {
    // border-radius: 8px;
    width: 85%;
    // width: 100%;
    height: 60vh;
  }

  &__container {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    background: var(--main-color);
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 500px) {
      border-radius: 8px;
      width: 100%;
      padding-right: 1.2em;
    }

    // background: red;
  }
}
.swiper-item {
  height: 350px;
  background: white;
  @media screen and (max-width: 500px) {
    // width: 100% !important;
    // margin-right: a;
    // background: red;
    // padding-left: 1em;
    // margin-right: 2.5em;
    // background: red;
    // margin-right: 0.65em;
  }
  //   border-radius: 10px;
  &__link {
    width: 100%;
    height: 100%;
    // background: blue;
    text-decoration: none;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // padding: .1em 0;
    flex-direction: column;
    transition: all 0.3s;
    // &:hover {
    //   transform: translate(0, -5px);
    //   box-shadow: 0 0px 5px rgba(0, 0, 0, 0.274);
    // }

    &_img {
      margin-top: 2em;
      width: 125px;
      height: 125px;
    }
    &_name {
      // background: red;
      color: var(--font-color);
      width: 100%;
      padding-right: 1em;
      margin-top: 2.8em;
      font-size: 0.8em;
    }
    &_prise {
      font-size: 0.9em;
      text-decoration: line-through;
      padding-left: 0.9em;
      text-align: left;
      width: 100%;
      // margin-top: 4em;
      color: var(--font-color);
    }
    &_dec {
      margin-right: auto;
      margin-left: 0.8em;
      margin-top: 0.2em;
      color: var(--main-color);
      background: var(--sub-color);
      border-radius: 20px;
      padding: 0.4em 0.8em;
      font-size: 0.8em;
    }
    &_prise_dec {
      letter-spacing: 0.05em;
      word-spacing: 0.2em;
      font-size: 1.2em;
      // text-decoration: line-through;
      padding-left: 0.9em;
      text-align: left;
      width: 100%;
      // margin-top: 4em;
      color: var(--font-color);
    }
  }
}
.dec_pri {
  margin-top: 2em;
  justify-content: center;
  align-items: center;
  // background: red;
  display: flex;
  width: 100%;
  height: 50px;
}
.swiper-button-next {
  border-radius: 50%;
  font-size: 0.5em;
  background-color: var(--sub-color);
  // right: 10px;
  padding: 20px;
  top: 50%;
  transform: translate(-25%, -40%);
  color: var(--main-color) !important;
  border: 1px solid var(--main-color);
  fill: var(--main-color) !important;
  stroke: var(--main-color) !important;
  @media screen and (max-width: 900px) {
    // font-size: 1em;
    display: none;
  }
}
.swiper-button-prev {
  border-radius: 50%;
  font-size: 0.5em;
  background-color: var(--sub-color);
  // right: 10px;
  padding: 20px;
  top: 50%;
  transform: translate(25%, -40%);
  color: var(--main-color) !important;
  border: 1px solid var(--main-color);
  fill: var(--main-color) !important;
  stroke: var(--main-color) !important;
  @media screen and (max-width: 900px) {
    // font-size: 1em;
    display: none;
  }
}
:root {
  --swiper-navigation-size: 17px;
  --swiper-navigation-size: 17px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/home.vue